import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"

import { ServiceCard } from "../service-card"
import { Link } from "react-router-dom"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"



export default function Diagnosticswidget() {
  return (
     <section className="py-12 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="grid items-center grid-cols-1 gap-8 md:grid-cols-2">
              <div>
                <Badge className="mb-2">Diagnostics</Badge>
                <h2 className="mb-4 text-3xl font-bold md:text-4xl">Advanced Diagnostic Services</h2>
                <p className="mb-6 text-muted-foreground">
                  Our state-of-the-art diagnostic center offers a comprehensive range of tests and imaging services with
                  quick and accurate results.
                </p>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-center gap-2">
                    <CheckCircle className="w-5 h-5 text-primary" />
                    <span>Complete Blood Tests & Pathology</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="w-5 h-5 text-primary" />
                    <span>Advanced Imaging (MRI, CT Scan, X-Ray)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="w-5 h-5 text-primary" />
                    <span>Cardiac Diagnostics</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="w-5 h-5 text-primary" />
                    <span>Walk-in Testing Available</span>
                  </li>
                </ul>
                <div className="flex flex-wrap gap-4">
                  <Button className="gap-2" asChild>
                  <a
                    href="https://pranaam365.com/"
                    className="flex items-center gap-2"
                  >
                    Book a Test
                    <Calendar className="w-4 h-4" />
                  </a>

                  </Button>
                  <Button
                    variant="outline"
                    className="gap-2 border-primary text-primary hover:bg-primary hover:text-white"
                    asChild
                  >
                    <a
                      href="https://pranaam365.com/book-tests"
                      className="inline-flex items-center gap-1 text-primary hover:underline"
                    >
                      View All Tests
                      <ChevronRight className="w-4 h-4" />
                    </a>


                  </Button>
                </div>
              </div>
              <div className="relative h-64 overflow-hidden rounded-lg md:h-80 lg:h-[500px]">
                <img
                  src= "/images/Advanced-Diagnostic-Services-Image.png"
                  alt="Advanced Diagnostic Services"
                  width={600}
                  height={400}
                  className="object-contain rounded-lg"
                />
               
              </div>
            </div>
          </div>
        </section>
  );
}

 